import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

import type { Column } from '@tanstack/vue-table';
    import { ArrowDown, ArrowUp, ChevronsUpDown } from 'lucide-vue-next';

    import { Button } from '@/components/ui/button';

    interface DataTableSortButtonProps {
        column: Column<any, any>;
        title: string;
        tableHasSelectedRows?: boolean;
    }

    
export default /*@__PURE__*/_defineComponent({
  __name: 'DataTableSortButton',
  props: {
    column: {},
    title: {},
    tableHasSelectedRows: { type: Boolean }
  },
  setup(__props: any) {

    const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Button), {
    variant: "ghost_primary",
    size: "sm",
    class: _normalizeClass(["data-[state=open]:bg-accent h-8 justify-start gap-0.5 px-0! text-xs font-semibold normal-case", { 'opacity-50': _ctx.tableHasSelectedRows }]),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.column.toggleSorting(_ctx.column.getIsSorted() === 'asc')))
  }, {
    default: _withCtx(() => [
      _createElementVNode("span", null, _toDisplayString(_ctx.title), 1),
      (_ctx.column.getIsSorted() === 'desc')
        ? (_openBlock(), _createBlock(_unref(ArrowDown), {
            key: 0,
            class: "size-3.5"
          }))
        : (_ctx.column.getIsSorted() === 'asc')
          ? (_openBlock(), _createBlock(_unref(ArrowUp), {
              key: 1,
              class: "size-3.5"
            }))
          : (_openBlock(), _createBlock(_unref(ChevronsUpDown), {
              key: 2,
              class: "size-3.5"
            }))
    ]),
    _: 1
  }, 8, ["class"]))
}
}

})